import React from 'react';
import Styles from '../pages/Index.module.css';

const EncerradasBox = () => {
  return (
    <div id="formulario-inscricao" className={Styles.container}>
      <h2>
        INSCRIÇÕES <span className={Styles.laranja}>ENCERRADAS</span>
      </h2>
      
      <div className={Styles.card}>
        <div className={Styles.encerradasBox}>
          {/* <span className={Styles.encerradasIcon}>🔒</span> */}
          {/* <p className={Styles.encerradasTitle}>INSCRIÇÕES ENCERRADAS</p> */}
          <p className={Styles.encerradasSubtitle}>
            Em breve, informaremos a abertura de novas turmas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EncerradasBox;